import moment from 'moment'
let util = {
  currencyFormatter: function (_data) {
    if (isNaN(_data)) return 'Rp. 0'

    const currency = 'Rp. '
    let result = ''
    let data = _data || 0
    if (data < 0) {
      data *= -1
      result = '(' + currency + data.toString() + ')'
    } else {
      result = currency + data.toString()
    }
    return result.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
  },
  formatTime: function (date) {
    let newDate = new Date(date)
    let dateHours = ('00' + newDate.getHours()).slice(-2)
    let dateMinutes = ('00' + newDate.getMinutes()).slice(-2)
    return dateHours + ':' + dateMinutes
  },
  rupiah: function (text) {
    if (!text) {
      text = 0
    }
    text = text.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
    let t = 'Rp. ' + text + ''
    return t
  },
  formatDecimal: function (data) {
    return data.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
  },
  invoiceDateTimeFormatter: function (datetime, string) {
    if (string === 'date') {
      return moment(datetime).format('DD MMM YYYY')
    } else if (string === 'time') {
      return moment(datetime).format('HH:mm')
    } else if (string === 'datetime') {
      return moment(datetime).format('DD MMM YYYY HH:mm')
    }
  }
}

export function formatTime (text) {
  return util.formatTime(text)
}

export function formatDecimal (text) {
  return util.formatDecimal(text)
}

export function negativeCurrencyFormatter (text) {
  let resultPrice = util.currencyFormatter(parseFloat(text).toFixed(0) * -1)
  if (resultPrice === 'Rp. -0') {
    resultPrice = 'Rp. 0'
  }

  return resultPrice
}

export function currencyFormatter (text) {
  let resultPrice = util.currencyFormatter(parseFloat(text).toFixed(0))
  if (resultPrice === 'Rp. -0') {
    resultPrice = 'Rp. 0'
  }

  return resultPrice
}

export function currencyFormatterWithoutFloat (text) {
  let resultPrice
  if (text) {
    resultPrice = util.currencyFormatter(parseFloat(text).toFixed(0))
    if (resultPrice === 'Rp. -0') {
      resultPrice = 'Rp. 0'
    }
  } else {
    resultPrice = text
  }
  return resultPrice
}

export function rupiahWithNegative (text) {
  if (!text && text !== 0) return ''
  let resultPrice = parseFloat(text).toFixed(0)
  let absPrice = Math.abs(resultPrice)
  if (resultPrice < 0) {
    return `(${rupiah(absPrice)})`
  } else {
    return rupiah(absPrice)
  }
}

export function percentWithNegative (text) {
  if (!text && text !== 0) return ''
  let resultPrice = parseFloat(text).toFixed(0)
  let absPrice = Math.abs(resultPrice)
  if (resultPrice < 0) {
    return `(${absPrice}%)`
  } else {
    return absPrice + '%'
  }
}

export function rupiahWithNegativeNumber (text) {
  if (!text && text !== 0) return ''
  let resultPrice = parseFloat(text).toFixed(0)
  let absPrice = Math.abs(resultPrice)
  return `(${rupiah(absPrice)})`
}

export function rupiahWithNegativeWithoutBracket (text) {
  if (!text && text !== 0) return ''
  let resultPrice = parseFloat(text)
  let absPrice = Math.abs(resultPrice)
  if (resultPrice < 0) {
    return `(${rupiah(absPrice)})`
  } else {
    return rupiah(absPrice)
  }
}

export function rupiah (text) {
  if (!text && text !== 0) return ''
  let resultPrice = util.rupiah(parseFloat(text).toFixed(0))
  if (resultPrice === 'Rp. -0') {
    resultPrice = 'Rp. 0'
  }
  return resultPrice
}

export function invoiceReceiptDateTime (datetime, string) {
  return util.invoiceDateTimeFormatter(datetime, string)
}

export function dateFormatter (datetime, format = 'DD-MM-YYYY') {
  return moment(datetime).format(format)
}

export function limitTo (foo, limit) {
  if (typeof foo === 'string') {
    return foo.substr(0, limit)
  } else if (Array.isArray(foo)) {
    return foo.slice(0, limit)
  } else {
    throw new Error(`first parameter of 'limitTo' must be string or array, instead get ${JSON.stringify(foo)}`)
  }
}

export function phoneNumberFormatter (phone) {
  let phoneNumber = phone.replace(/-/g, '')
  let phoneNumberFormatted
  if (phoneNumber.match(/^62/)) {
    phoneNumberFormatted = phoneNumber.replace(/^62/, '')
  } else if (phoneNumber.match(/^0/)) {
    phoneNumberFormatted = phoneNumber.replace(/^0/, '')
  }
  return phoneNumberFormatted
}



// WEBPACK FOOTER //
// ./app/utils/formatter.js